module.exports = __webpack_public_path__ + "static/media/2.e7e1c8a7.jpg";